<script type="text/babel">
  function fakeReresh() {
    var i = document.createElement('iframe');
    i.src = '/favicon.ico';
    i.style.display = 'none';
    i.onload = function() {
      setTimeout(function(){
        i.remove();
      }, 0)
    };
    document.body.appendChild(i);
  }

  export default {
    props: ['title'],
    mounted () {
      document.title = this.title;
      fakeReresh()
    },
    watch: {
      title () {
        document.title = this.title;
        fakeReresh()
      }
    },
    render () {
    },
  }
</script>



// WEBPACK FOOTER //
// dynamicTitle.vue?c7dee92c